import s from "@babel/runtime/helpers/esm/slicedToArray";
import i from "react";
import { createBaseComponent as n } from "@semcore/core";
import p from "./useFlex.mjs";
function r(o, t) {
  var a = p(o, t), e = s(a, 2), m = e[0], l = e[1];
  return /* @__PURE__ */ i.createElement(m, l);
}
r.displayName = "Flex";
const F = n(r);
export {
  F as default
};
